import { render, staticRenderFns } from "./IssueStatus.vue?vue&type=template&id=44ccf0d2&scoped=true&"
import script from "./IssueStatus.vue?vue&type=script&lang=ts&"
export * from "./IssueStatus.vue?vue&type=script&lang=ts&"
import style0 from "./IssueStatus.vue?vue&type=style&index=0&id=44ccf0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ccf0d2",
  null
  
)

export default component.exports